import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AddUpdateUI from "./AddUpdateUI.jsx";
import { getCountries } from "../../../services/CommonServices";

const AddUpdateState = ({ formik, relationData }) => {
  const dispatch = useDispatch();
  const [selectedCountry, setSelectedCountry] = useState({});

  useEffect(() => {
    dispatch(getCountries());
    if (relationData && Object.keys(relationData).length > 0) {
      setSelectedCountry({
        label: relationData.country.name,
        value: relationData.country._id,
      });
    }
  }, [relationData]);

  return (
    <AddUpdateUI
      formik={formik}
      selectedCountry={selectedCountry}
      setSelectedCountry={setSelectedCountry}
    />
  );
};

export default AddUpdateState;
